// extracted by mini-css-extract-plugin
module.exports = {"HeaderSearch":"HeaderSearch_HeaderSearch__2iMXa"};